import { api } from './api';
import type { Employee } from '../types';

export const employeesApi = {
  list: () => api.get<Employee[]>('/employees'),
  create: (data: Partial<Employee>) => api.post<Employee>('/employees', data),
  update: (id: number, data: Partial<Employee>) => api.patch<Employee>(`/employees/${id}`, data),
  remove: (id: number) => api.delete<{ ok: boolean }>(`/employees/${id}`),
};
